export default __webpack_public_path__ + "static/superstructure_w.9181d21252b795ddc1bb67616d3a30df.png";